<template>
  <div>
    <table class="table table-sm">
      <thead class="thead-light">
        <tr>
          <th>Project Name</th>
          <th>Sub Project</th>
          <th>Location</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in projectInfo" :key="index">
          <td>{{ item['Project Name'] }}</td>
          <td>{{ item['Sub Project'] }}</td>
          <td>{{ item.Location }}</td>
          <td>
            <span class="badge badge-success" v-if="item.Status === 'Active'">
              Active
            </span>
            <span class="badge badge-secondary" v-else> Inactive </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ProjectInfo',
  data() {
    return {
      projectInfo: [
        {
          'Project Name': 'KPC Project',
          'Sub Project': 'Long Hauling',
          Location: 'Sangatta',
          Status: 'Active',
        },
        {
          'Project Name': 'KPC Project',
          'Sub Project': 'Transhipment',
          Location: 'Sangatta',
          Status: 'Active',
        },
        {
          'Project Name': 'KPC Project',
          'Sub Project': 'Assist Tug',
          Location: 'Sangatta',
          Status: 'Active',
        },
      ],
    }
  },
}
</script>
